export type ExpenseSettlementFilter =
  | "all"
  | "settled"
  | "partial"
  | "unsettled";
export type ExpenseEngagementFilter = "all" | "engaged" | "notengaged";

export interface ExpenseFilterCriteria {
  chapter: string;
  settlement: ExpenseSettlementFilter;
  engagement: ExpenseEngagementFilter;
}

export const DEFAULT_EXPENSE_CRITERIA: ExpenseFilterCriteria = {
  chapter: "all",
  settlement: "all",
  engagement: "all",
};
